"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var subproviders_1 = require("@0x/subproviders");
var connector_1 = __importDefault(require("./connector"));
var WalletConnectConnector = /** @class */ (function (_super) {
    __extends(WalletConnectConnector, _super);
    function WalletConnectConnector(kwargs) {
        var _this = this;
        var WalletConnectSubprovider = kwargs.api, bridge = kwargs.bridge, supportedNetworkURLs = kwargs.supportedNetworkURLs, defaultNetwork = kwargs.defaultNetwork;
        var supportedNetworks = Object.keys(supportedNetworkURLs).map(function (supportedNetworkURL) { return Number(supportedNetworkURL); });
        _this = _super.call(this, { supportedNetworks: supportedNetworks }) || this;
        _this.WalletConnectSubprovider = WalletConnectSubprovider;
        _this.bridge = bridge;
        _this.supportedNetworkURLs = supportedNetworkURLs;
        _this.defaultNetwork = defaultNetwork;
        _this.connectAndSessionUpdateHandler = _this.connectAndSessionUpdateHandler.bind(_this);
        _this.disconnectHandler = _this.disconnectHandler.bind(_this);
        return _this;
    }
    WalletConnectConnector.prototype.onActivation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var walletConnectSubprovider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.walletConnectSubprovider && !this.walletConnector) {
                            walletConnectSubprovider = new this.WalletConnectSubprovider({ bridge: this.bridge });
                            this.walletConnectSubprovider = walletConnectSubprovider;
                            this.walletConnector = this.walletConnectSubprovider._walletConnector;
                        }
                        if (!!this.walletConnector.connected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.walletConnector.createSession()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // initialize event listeners
                        this.walletConnector.on('connect', this.connectAndSessionUpdateHandler);
                        this.walletConnector.on('session_update', this.connectAndSessionUpdateHandler);
                        this.walletConnector.on('disconnect', this.disconnectHandler);
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletConnectConnector.prototype.getProvider = function (networkId) {
        return __awaiter(this, void 0, void 0, function () {
            var networkIdToUse, engine;
            return __generator(this, function (_a) {
                // this should never happened, because it probably means there was a funky walletconnect race condition
                if (networkId && this.walletConnector.chainId && networkId !== this.walletConnector.chainId) {
                    throw Error('Unexpected Error in WalletConnectConnector. Please file an issue on Github.');
                }
                networkIdToUse = this.walletConnector.chainId || networkId || this.defaultNetwork;
                _super.prototype._validateNetworkId.call(this, networkIdToUse);
                engine = new subproviders_1.Web3ProviderEngine();
                this.engine = engine;
                engine.addProvider(this.walletConnectSubprovider);
                engine.addProvider(new subproviders_1.RPCSubprovider(this.supportedNetworkURLs[networkIdToUse]));
                engine.start();
                return [2 /*return*/, engine];
            });
        });
    };
    WalletConnectConnector.prototype.getAccount = function (provider) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.walletConnector.connected) {
                    return [2 /*return*/, _super.prototype.getAccount.call(this, provider)];
                }
                else {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/];
            });
        });
    };
    WalletConnectConnector.prototype.onDeactivation = function () {
        // TODO remove listeners here once exposed in walletconnect
        if (this.engine) {
            this.engine.stop();
        }
    };
    // walletconnect event handlers
    WalletConnectConnector.prototype.connectAndSessionUpdateHandler = function (error, payload) {
        if (error) {
            _super.prototype._web3ReactErrorHandler.call(this, error);
        }
        else {
            var _a = payload.params[0], chainId = _a.chainId, accounts = _a.accounts;
            // proactively handle wrong network errors
            try {
                _super.prototype._validateNetworkId.call(this, chainId);
                _super.prototype._web3ReactUpdateHandler.call(this, {
                    updateNetworkId: true,
                    updateAccount: true,
                    networkId: chainId,
                    account: accounts[0]
                });
            }
            catch (error) {
                _super.prototype._web3ReactErrorHandler.call(this, error);
            }
        }
    };
    WalletConnectConnector.prototype.disconnectHandler = function (error) {
        if (error) {
            _super.prototype._web3ReactErrorHandler.call(this, error);
        }
        else {
            _super.prototype._web3ReactResetHandler.call(this);
        }
    };
    return WalletConnectConnector;
}(connector_1.default));
exports.default = WalletConnectConnector;
//# sourceMappingURL=walletconnect.js.map